import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {SessionService} from '@core/services/session.service';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AdminAnonymousGuard implements CanActivate, CanActivateChild {

    constructor(private _router: Router,
                private _session: SessionService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Check if the user has access.
        const isAuthenticatedAsAdmin = this._session.isAdmin || this._session.isAgent || this._session.isPlatformAdmin;

        // Check if the token does exist.
        if (isAuthenticatedAsAdmin) {
            this._router.navigate(['/admin/dashboard']).then(_ => _);
        }

        return !isAuthenticatedAsAdmin;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(childRoute, state);
    }

}
